// src/pages/GiveSubscription.js
import React, { useState } from 'react';
import { Button, Container, Form } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import './PageStyles.css';

const GiveSubscription = () => {
  const [userId, setUserId] = useState('');
  const [day, setDay] = useState(31);
  const [subscriptionType, setSubscriptionType] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const navigate = useNavigate();

  const handleGiveSubscription = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setSuccess(null);

    try {
      const response = await axios.post('https://crystaldev.ru/apiavrora', {
        method: 'give',
        id: userId,
        day: day,
        subscription: subscriptionType
      }, {
        headers: { 'Content-Type': 'application/json' },
      });

      setSuccess('Подписка успешно выдана');
    } catch (error) {
      setError('Ошибка при выполнении запроса');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container className="mt-4">
      <div className="back-button-container">
        <Button variant="secondary" onClick={() => navigate('/admin3')}>Вернуться назад</Button>
      </div>
      <div className="d-flex flex-column align-items-center">
        <h1>Выдать подписку</h1>
        <Form onSubmit={handleGiveSubscription}>
          <Form.Group controlId="give-subscription">
            <Form.Label>Введите ID пользователя</Form.Label>
            <Form.Control
              type="text"
              placeholder="Введите id"
              value={userId}
              onChange={(e) => setUserId(e.target.value)}
              required
            />
          </Form.Group>
          <Form.Group controlId="subscription-type" className="mt-3">
            <Form.Label>Выберите тип подписки</Form.Label>
            <Form.Control
              as="select"
              value={subscriptionType}
              onChange={(e) => setSubscriptionType(e.target.value)}
              required
            >
              <option value="">Выберите подписку</option>
              <option value="start">Start</option>
              <option value="master">Master</option>
              <option value="year">Годовой</option>
            </Form.Control>
          </Form.Group>
          <Form.Group controlId="give-subscription">
            <Form.Label>Введите кол во дней</Form.Label>
            <Form.Control
              type="Number"
              min={0}
              max={365}
              placeholder="Введите кол во дней"
              value={day}
              onChange={(e) => setDay(e.target.value)}
              required
            />
          </Form.Group>
          <Button variant="primary" type="submit" className="mt-3" disabled={loading}>
            {loading ? 'Выдача...' : 'Выдать'}
          </Button>
        </Form>
        {error && <p className="text-danger mt-3">{error}</p>}
        {success && <p className="text-success mt-3">{success}</p>}
      </div>
    </Container>
  );
};

export default GiveSubscription;
